'use client';

export function SkuImageSkeleton() {
  return (
    <div className="tw-flex tw-h-full tw-w-full tw-animate-pulse tw-items-center tw-justify-center tw-bg-gray-200">
      <div className="tw-h-20 tw-w-16 tw-rounded tw-bg-gray-300" />
    </div>
  );
}

export function SkuNameSkeleton() {
  return (
    <div className="tw-space-y-2">
      <div className="tw-h-5 tw-animate-pulse tw-rounded tw-bg-gray-200" />
      <div className="tw-h-5 tw-w-3/4 tw-animate-pulse tw-rounded tw-bg-gray-200" />
    </div>
  );
}

export function SkuDescriptionSkeleton() {
  return (
    <div className="tw-space-y-2">
      <div className="tw-h-4 tw-animate-pulse tw-rounded tw-bg-gray-200" />
      <div className="tw-h-4 tw-w-5/6 tw-animate-pulse tw-rounded tw-bg-gray-200" />
    </div>
  );
}

export function SkuPriceSkeleton() {
  return (
    <div className="tw-space-y-2">
      <div className="tw-h-3 tw-w-20 tw-animate-pulse tw-rounded tw-bg-gray-200" />
      <div className="tw-h-6 tw-w-16 tw-animate-pulse tw-rounded tw-bg-gray-200" />
    </div>
  );
}

export function WishlistButtonSkeleton() {
  return <div className="tw-h-10 tw-w-10 tw-animate-pulse tw-rounded-full tw-bg-gray-200" />;
}
